import { ReactNode } from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import styles from "./Menu.module.css";
import { cx } from "../utils";

export interface MenuProps {
    children: ReactNode;
}

interface MenuContentProps {
    children: ReactNode;
    align?: "start" | "center" | "end";
    sideOffset?: number;
    className?: string;
}

interface MenuItemProps {
    icon?: ReactNode;
    children: ReactNode;
    onClick?: () => void;
    danger?: boolean;
    disabled?: boolean;
    className?: string;
}

const MenuRoot = ({ children }: MenuProps) => <DropdownMenu.Root>{children}</DropdownMenu.Root>;

const MenuTrigger = DropdownMenu.Trigger;

const MenuContent = ({ children, align = "end", sideOffset = 4, className }: MenuContentProps) => (
    <DropdownMenu.Portal>
        <DropdownMenu.Content align={align} sideOffset={sideOffset} className={cx(styles.content, className)}>
            {children}
        </DropdownMenu.Content>
    </DropdownMenu.Portal>
);

const MenuItem = ({ icon, children, onClick, danger = false, disabled = false, className }: MenuItemProps) => (
    <DropdownMenu.Item
        className={cx(styles.item, danger && styles.itemDanger, className)}
        onClick={onClick}
        disabled={disabled}
    >
        {icon ? <span className={styles.itemIcon}>{icon}</span> : null}
        <span>{children}</span>
    </DropdownMenu.Item>
);

const MenuSeparator = () => <DropdownMenu.Separator className={styles.separator} />;

export const Menu = Object.assign(MenuRoot, {
    Trigger: MenuTrigger,
    Content: MenuContent,
    Item: MenuItem,
    Separator: MenuSeparator,
});
